import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import GetInTouch from "./sections/GetInTouch";
import WhyChooseUs from "./sections/WhyChooseUs";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <GetInTouch />
      <WhyChooseUs />
      <Footer />
    </div>;
}